import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const NoDataAvailable = styled.div`
  display: flex;
  justify-content: center;
  font-weight: ${fontWeights.bold};
  margin: 3em 0;
  color: ${colours.darkGrey};
`;
